package team.platforma.materialextension.theme

import androidx.compose.foundation.shape.CutCornerShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import team.platforma.multiplatform_material_extension.calendar.style.BadgeStyle
import team.platforma.multiplatform_material_extension.calendar.style.CalendarViewStyle
import team.platforma.multiplatform_material_extension.calendar.style.CellPadding
import team.platforma.multiplatform_material_extension.calendar.style.DateStyle
import team.platforma.multiplatform_material_extension.calendar.style.EndPeriod
import team.platforma.multiplatform_material_extension.calendar.style.PeriodPadding
import team.platforma.multiplatform_material_extension.calendar.style.PeriodStyle
import team.platforma.multiplatform_material_extension.calendar.style.PickerStyle
import team.platforma.multiplatform_material_extension.calendar.style.PikerButton
import team.platforma.multiplatform_material_extension.calendar.style.StartPeriod
import team.platforma.multiplatform_material_extension.calendar.style.TrackPeriod
import team.platforma.multiplatform_material_extension.ui.dialog.style.DialogStyle

class CalendarTheme {
    @Composable
    fun light() {
        CalendarViewStyle.define(
            dateStyle = DateStyle(
                shape = CutCornerShape(topStartPercent = 50, bottomEndPercent = 50),
                cellPadding = CellPadding(
                    horizontal = 6.dp,
                    vertical = 6.dp
                )
            ),
            periodStyle = PeriodStyle(
                startPeriod = StartPeriod(
                    shape = CutCornerShape(topStartPercent = 50),
                    padding = PeriodPadding(top = 2.dp, bottom = 2.dp, start = 2.dp)
                ),
                endPeriod = EndPeriod(
                    shape = CutCornerShape(bottomEndPercent = 50),
                    padding = PeriodPadding(top = 2.dp, bottom = 2.dp, end = 2.dp)
                ),
                trackPeriod = TrackPeriod(
                    padding = PeriodPadding(top = 2.dp, bottom = 2.dp)
                )
            ),
            pikerStyle = PickerStyle(
                dialogStyle = DialogStyle(
                    shape = CutCornerShape(16.dp)
                ),
                button = PikerButton(
                    style = MaterialTheme.typography.bodyMedium.copy(
                        fontWeight = FontWeight.Bold
                    )
                )
            )

        )
    }

    @Composable
    fun dark() {
        CalendarViewStyle.define(
            dateStyle = DateStyle(
                shape = RoundedCornerShape(100),
                cellPadding = CellPadding(
                    horizontal = 6.dp,
                    vertical = 6.dp
                )
            ),
            periodStyle = PeriodStyle(
                startPeriod = StartPeriod(
                    shape = RoundedCornerShape(topStartPercent = 100, bottomStartPercent = 100),
                    padding = PeriodPadding(top = 2.dp, bottom = 2.dp, start = 2.dp)
                ),
                endPeriod = EndPeriod(
                    shape = RoundedCornerShape(topEndPercent = 100, bottomEndPercent = 100),
                    padding = PeriodPadding(top = 2.dp, bottom = 2.dp, end = 2.dp)
                ),
                trackPeriod = TrackPeriod(
                    padding = PeriodPadding(top = 2.dp, bottom = 2.dp)
                )
            ),
            pikerStyle = PickerStyle(
                dialogStyle = DialogStyle(
                    shape = RoundedCornerShape(16.dp),
                    borderColor = Color.Green
                ),
                button = PikerButton(
                    style = MaterialTheme.typography.bodyMedium.copy(
                        fontWeight = FontWeight.Bold
                    )
                )
            )
        )
    }
}